import dayjs from "dayjs";
import i18n from "@/plugins/i18n.js";
import { capitalize } from "@/tools/filters.js";

function roundToNearestHalfMinutes(time) {
  let maDate = new Date("2000-01-01T" + time + ":00");
  let roundedDate = new Date(
    Math.round((maDate.getTime() - 900000) / 1800000) * 1800000
  );
  let hours = roundedDate.getHours();

  return (
    (hours < 10 ? "0" : "") +
    hours +
    ":" +
    ("0" + roundedDate.getMinutes()).substr(-2)
  );
}

function generateDateIntoInterval(dateArray, holidays = []) {
  let res = [];
  let current = dayjs(dateArray[0]).hour(9).minute(0).second(0);
  let end = dayjs(dateArray[1]).hour(9).minute(0).second(0);
  let i = 0;
  while (current.isSameOrBefore(end) && i < 36) {
    // Add date if it is not a weekend
    let dayFormat = current.format("YYYY-MM-DD");

    if (![0, 6].includes(current.day()) && !holidays.includes(dayFormat)) {
      res.push(dayFormat);
    }
    current = current.add(1, "day");
    i += 1;
  }

  return res;
}

function getLocalizedDateFormat(date) {
  return dayjs(date).format("LL");
}

function getLocalizedDatetimeFormat(date) {
  return dayjs(date).format("LLL");
}

function getFirstDayByYear(date) {
  return dayjs(date).dayOfYear(1).format("YYYY-MM-DD");
}

function getLocalizedWeekFormat(date) {
  let weekDayJs = dayjs(date);
  let res = `${capitalize(i18n.t("date.from"))} ${weekDayJs
    .day(1)
    .format("LL")}`;
  res += ` ${i18n.t("date.to")} ${weekDayJs.day(7).format("LL")}`;
  res += ` (${capitalize(i18n.t("date.weekAbr"))}${weekDayJs.isoWeek()})`;

  return res;
}

function getDayMonthDateFormat(date) {
  return dayjs(date).format("DD/MM");
}

function getDayMonthYearDateFormat(date) {
  if (!date) {
    return null;
  }
  return dayjs(date).format("DD/MM/YY");
}

function getWeekDateFormat(date) {
  return date ? dayjs(date).isoWeek() : dayjs().isoWeek();
}

function getYearDateFormat(date) {
  if (!date) {
    return dayjs().isoWeekYear();
  }

  const dayJsDate = dayjs(date);
  return dayJsDate.isoWeekYear();
}

function getDurationFormat(minutes) {
  const prefix = minutes < 0 ? "- " : "";
  const duration = Math.abs(minutes);

  return (
    prefix +
    Math.floor(duration / 60) +
    "h" +
    String(duration % 60).padStart(2, "0")
  );
}

function getMondayDateFromWeek(year, weekNumber) {
  return dayjs().year(year).isoWeek(weekNumber).weekday(0).format("YYYY-MM-DD");
}

// retour date formaté dd-mm-yyy un mois avant
// la date donnée en paramètre, depuis ajd sinon.
function getNbMonthBefore(date, nbMonth = 1) {
  return dayjs(date).subtract(nbMonth, "month").day(1).format("YYYY-MM-DD");
}

// retour date formaté dd-mm-yyy un mois après
// la date donnée en paramètre, depuis ajd sinon.
function getNbMonthAfter(date, nbMonth = 1) {
  return dayjs(date).add(nbMonth, "month").day(1).format("YYYY-MM-DD");
}

/**
 * Détermine si une semaine à partir d'une date donnée s'étend sur deux années différentes.
 *
 * @param {string} date
 */
function isMultiYearWeek(date) {
  const dayjsDate = dayjs(date);

  if (!dayjsDate.isValid()) {
    return false;
  }

  const start = dayjsDate.startOf("week");
  const end = dayjsDate.endOf("week");

  return start.year() !== end.year();
}

/**
 * @param {Week} week
 */
function getEffectiveYears(week) {
  const yearStart = dayjs()
    .year(week.year)
    .isoWeek(week.weekNumber)
    .startOf("week")
    .year();

  const yearEnd = dayjs()
    .year(week.year)
    .isoWeek(week.weekNumber)
    .endOf("week")
    .year();

  const years = [];

  if (!years.includes(yearStart)) {
    years.push(yearStart);
  }

  if (!years.includes(yearEnd)) {
    years.push(yearEnd);
  }

  return years;
}

export {
  generateDateIntoInterval,
  getLocalizedDateFormat,
  getLocalizedDatetimeFormat,
  getDurationFormat,
  getLocalizedWeekFormat,
  getDayMonthDateFormat,
  getWeekDateFormat,
  getYearDateFormat,
  getFirstDayByYear,
  getNbMonthBefore,
  getNbMonthAfter,
  roundToNearestHalfMinutes,
  getMondayDateFromWeek,
  getDayMonthYearDateFormat,
  isMultiYearWeek,
  getEffectiveYears,
};
